import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../theme";

function TermsAndConditions() {
  const { colors } = useContext(ThemeContext)!;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <div className={`min-h-screen ${colors.bgSecondaryColor}`}>
      <div className="container mx-auto px-6 py-4 md:py-20 max-w-5xl">
        <div
          className={`transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
        >
          <h1 className={`text-4xl md:text-5xl font-black ${colors.textColor} mb-6`}>
            Terms and Conditions
          </h1>

          <p className={`${colors.textColor} opacity-70 mb-10`}>
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section className="space-y-8 text-lg leading-relaxed">
            {/* 1 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                1. Acceptance of Terms
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                By downloading, accessing, or using the I Call On mobile application, website,
                or related services (collectively, the “Service”), you agree to be bound by
                these Terms and Conditions. If you do not agree to these Terms, you must not
                access or use the Service.
              </p>
            </div>

            {/* 2 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                2. Eligibility
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                You must be at least 13 years old to use I Call On. If you are under the age
                of majority in your jurisdiction, you confirm that you have permission from
                a parent or legal guardian. You are responsible for ensuring that your use of
                the Service complies with all applicable laws.
              </p>
            </div>

            {/* 3 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                3. Account Registration
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                Some features of the Service require creating an account. You agree to provide
                accurate, current, and complete information and to keep your account details
                updated. You are solely responsible for all activities that occur under your
                account.
              </p>
            </div>

            {/* 4 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                4. Gameplay and Fair Use
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                I Call On is designed to be played fairly and competitively. You agree not to:
              </p>
              <ul className={`${colors.textColor} opacity-80 list-disc list-inside mt-2 space-y-2`}>
                <li>Cheat, exploit bugs, or manipulate game mechanics</li>
                <li>Use bots, scripts, or automation tools</li>
                <li>Intentionally disrupt games or other players</li>
                <li>Abuse scoring systems or validation processes</li>
              </ul>
            </div>

            {/* 5 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                5. User-Generated Content
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                The Service allows users to submit text content during gameplay. You retain
                ownership of your content, but by submitting it, you grant I Call On a
                worldwide, non-exclusive, royalty-free license to use, display, and process
                such content solely for operating and improving the Service.
              </p>
            </div>

            {/* 6 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                6. Prohibited Conduct
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                You agree not to submit content that is unlawful, abusive, defamatory,
                hateful, sexually explicit, or otherwise offensive. I Call On reserves the
                right to remove content and suspend or terminate accounts that violate these
                rules.
              </p>
            </div>

            {/* 7 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                7. Intellectual Property
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                All trademarks, logos, game mechanics, designs, and software associated with
                I Call On are the exclusive property of I Call On and its licensors. You may
                not copy, modify, distribute, or reverse engineer any part of the Service.
              </p>
            </div>

            {/* 8 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                8. In-App Purchases (If Applicable)
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                I Call On may offer optional in-app purchases. All purchases are final and
                non-refundable except where required by law or platform policies. Prices may
                change at any time.
              </p>
            </div>

            {/* 9 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                9. Service Availability
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                We strive to keep the Service available at all times, but we do not guarantee
                uninterrupted access. Features may change, be suspended, or discontinued at
                any time without notice.
              </p>
            </div>

            {/* 10 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                10. Disclaimer of Warranties
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                The Service is provided “as is” and “as available.” I Call On makes no warranties,
                express or implied, regarding the reliability, accuracy, or availability of
                the Service.
              </p>
            </div>

            {/* 11 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                11. Limitation of Liability
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                To the maximum extent permitted by law, I Call On shall not be liable for any
                indirect, incidental, consequential, or punitive damages arising from your
                use of the Service.
              </p>
            </div>

            {/* 12 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                12. Termination
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                We may suspend or terminate your access to the Service at any time if you
                violate these Terms or engage in behavior harmful to the community.
              </p>
            </div>

            {/* 13 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                13. Changes to These Terms
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                We reserve the right to update these Terms at any time. Continued use of the
                Service after changes take effect constitutes acceptance of the updated Terms.
              </p>
            </div>

            {/* 14 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                14. Governing Law
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                These Terms shall be governed and interpreted in accordance with the laws of
                your applicable jurisdiction, without regard to conflict of law principles.
              </p>
            </div>

            {/* 15 */}
            <div>
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                15. Contact Information
              </h2>
              <p className={`${colors.textColor} opacity-80`}>
                If you have any questions about these Terms, please contact us through the
                official I Call On support channels.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
